// This is a vanilla JS riff on the jQuery solution in the link below:
// https://www.driftingruby.com/episodes/nested-forms-from-scratch#show_notes

///////////////////////////////////////////////////////////////////
//
// Event Listeners
//
///////////////////////////////////////////////////////////////////

(function() {
  document.addEventListener('turbolinks:load', (e) => {
    const addFieldsLink     = document.querySelector('.add_fields'),
          positionalElement = document.querySelector('.positional');

    if (addFieldsLink) {
      addFieldsLink.addEventListener('click', addSection);

      if (positionalElement) {
        addFieldsLink.addEventListener('click', setPositionValues);
        addFieldsLink.addEventListener('click', setPositionText);
        addFieldsLink.addEventListener('click', disableUpDown);
      }


      if (document.querySelector('.card.js-nested-form-container')) {
        if (positionalElement) {
          disableUpDown();
          setPositionValues();

          document.querySelectorAll('button.move-up, button.move-down').forEach(function(button) {
            button.addEventListener('click', moveCard);
          });
        }

        document.querySelectorAll('.delete_record').forEach(function(button) {
          button.addEventListener('click', toggleDelete);
        });
      }
    }
  });



  ///////////////////////////////////////////////////////////////////
  //
  // Callbacks
  //
  ///////////////////////////////////////////////////////////////////

  ///////////////////////////////////////////////
  //
  // Description - Adds form section with associated deletion
  //               listener. Works with any model that accepts
  //               nested attributes for a child association.
  //
  // Use case    - Implement anywhere there's a need for the
  //               dynamic addition, deletion, or reordering
  //               of nested child forms.
  //
  // Ex. Standards Revision (parent)/Process Review Section (child)
  //
  function addSection(e) {
    const target         = e.target,
          fieldsParent   = document.querySelector('.fields'),
          regexp         = new RegExp(target.dataset.id, 'g'),
          time           = new Date().getTime(),
          range          = document.createRange(),
          content        = target.dataset.fields.replace(regexp, time),
          newSectionNode = range.createContextualFragment(content);

    fieldsParent.appendChild(newSectionNode);

    // These declarations depend on the preceding appendChild call and can't
    // be moved to the top of the function.
    // eslint-disable-next-line one-var
    const newSection    = fieldsParent.lastElementChild,
          newDeleteLink = newSection.querySelector('.remove_record');

    // Add event listener to new nested form's delete link.
    newDeleteLink.addEventListener('click', (e) => {
      // Delete nested form HTML entirely
      fieldsParent.removeChild(newDeleteLink.closest('.js-nested-form-container'));

      if (document.querySelector('.positional')) {
        disableUpDown();

        setPositionValues();

        setPositionText();
      }

      return e.preventDefault();
    });

    if (document.querySelector('.positional')) {
      // Add event listener to new nested form's up and down buttons
      const newUpDownButtons = newSection.querySelectorAll('button.move-up, button.move-down');
      newUpDownButtons.forEach(function(button) {
        button.addEventListener('click', moveCard);
      });
    }

    return e.preventDefault();
  }

  ///////////////////////////////////////////////
  //
  // Description - Iterates over position fields setting value.
  //
  function setPositionValues() {
    // grab all position fields
    const positionIdSelector = '[id$="_position"]',
          positionFields = document.querySelectorAll(positionIdSelector);

    // iterate over collection and set position values
    positionFields.forEach(function(field, index) {
      field.value = index + 1;
    });
  }

  ///////////////////////////////////////////////
  //
  // Description - Iterates over cards setting h4
  //               inner text using position value.
  //
  // Use case    - This method should only be invoked after
  //               setPositionValues() has run.
  //
  function setPositionText() {
    const cards = document.querySelectorAll('.card.js-nested-form-container');
    let positionElement, positionIdSelector, positionValue;

    cards.forEach(function(card) {
      positionIdSelector = '[id$="_position"]';
      positionValue = card.querySelector(positionIdSelector).value;
      positionElement = card.querySelector('h4.position');

      positionElement.innerText = positionValue;
    });
  }

  ///////////////////////////////////////////////
  //
  // Description - Disables up button on first card
  //               and down button on last card.
  //
  function disableUpDown() {
    let upButtons, firstUpButton, downButtons, lastDownButton;

    // reset by enabling all up and down buttons before
    // targeting first and last buttons for disable
    const upDownButtons = document.querySelectorAll(".move-up, .move-down");

    if (upDownButtons.length > 0) {
      upDownButtons.forEach(function(button) {
        button.removeAttribute("disabled");
      });

      // disable first up button
      upButtons = document.querySelectorAll('.move-up');
      firstUpButton = upButtons[0];
      firstUpButton.setAttribute("disabled", "disabled");

      // disable last down button
      downButtons = document.querySelectorAll('.move-down');
      lastDownButton = downButtons[downButtons.length - 1];
      lastDownButton.setAttribute("disabled", "disabled");
    }
  }

  ///////////////////////////////////////////////
  //
  // Description - Moves card up or down on arrow
  //               click.
  //
  function moveCard(e) {
    let nextCard;

    const target = e.currentTarget,
          movingUp = target.classList.contains("move-up"),
          parentNode = document.querySelector('.fields'),
      //  get parent card of click event target
          targetCard = target.closest('.card.js-nested-form-container');

    // get previous or next card according to arrow
    if (movingUp) {
      nextCard = getSibling(targetCard, '.card.js-nested-form-container', 'up');
    } else if (target.classList.contains("move-down")) {
      nextCard = getSibling(targetCard, '.card.js-nested-form-container', 'down');
    }

    // prepend or append according to arrow
    if (movingUp) {
      parentNode.insertBefore(targetCard, nextCard);
    } else {
      parentNode.insertBefore(nextCard, targetCard);
    }

    disableUpDown();

    setPositionValues();

    setPositionText();
  }

  ///////////////////////////////////////////////
  //
  // Description - Traverse DOM looking for sibling
  //               that matches given selector.
  //
  // Use case    - Currently used inside of moveCard()
  //               for finding sibling to switch
  //               positions with.
  //
  function getSibling(element, selector, direction) {
    let sibling;

    // get next sibling element
    if (direction == 'up') {
      sibling = element.previousElementSibling;
    } else if (direction == 'down') {
      sibling = element.nextElementSibling;
    }

    // walk through sibling elements until we find
    // the matching selector
    while (sibling) {
      if (sibling.matches(selector)) return sibling;

      if (direction == 'up') {
        sibling = sibling.previousElementSibling;
      } else if (direction == 'down') {
        sibling = sibling.nextElementSibling;
      }
    }
  }

  ///////////////////////////////////////////////
  //
  // Description - Toggles hidden _delete value on
  //               persisted nested records
  //
  function toggleDelete(e) {
    const target = e.target,
          targetCard = target.closest('.card.js-nested-form-container'),
          destroyIdSelector = '[id$="_destroy"]',
          deleteField = targetCard.querySelector(destroyIdSelector);

    // toggle _destroy value and deletion styles
    if (deleteField.value === 'false') {
      deleteField.value = 1;
      targetCard.classList.add('for-delete');
      target.innerHTML = '<i class="fas fa-undo"></i>';
      target.title = 'Set for delete. Click to undo.';
    } else {
      deleteField.value = false;
      targetCard.classList.remove('for-delete');
      target.innerHTML = '<i class="fas fa-trash"></i>';
      target.title = 'Delete';
    }

    return e.preventDefault();
  }
}());
